<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { ListIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ escapeList: true, onlyIfEmpty: true }))
    .toggleBulletList()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="ListIcon"
    shortcut="-"
    @click="run"
    @keydown.enter="run"
  >
    Bulleted list
  </SuggestionListItem>
</template>
